import { useSessionStorage } from "../misc/useSessionStorage";

export const useLastSeenClient = () => {
  const [lastSeenClientId, setLastSeenClientId] = useSessionStorage<
    string | null
  >("last_seen_client_id");

  return { lastSeenClientId, setLastSeenClientId };
};
